import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import ProjectDocuments from "./ProjectDocuments"; // Importing your table component

export default function ProjectDocumentsPage() {
    // Extract the projectId from the URL (e.g., /admin/projects/123/documents)
    const { projectId } = useParams<{ projectId: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const projectName = location.state?.name || `ID: ${projectId}`;
    if (!projectId) {
        return <div className="p-6 text-red-500">Error: Project ID missing from URL.</div>;
    }

    return (
        <div className="text-slate-900 dark:text-white bg-white dark:bg-gray-800 transition-colors duration-300 rounded-lg h-full min-h-[calc(100vh-130px)]">

            {/* Header & Back Navigation */}
            <div className="p-4 sm:p-6  flex items-center gap-4">
                <button
                    onClick={() => navigate(-1)} // Takes the user back to the Projects list
                    className="p-2 rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
                    aria-label="Go back"
                >
                    <FaArrowLeft className="text-gray-600 dark:text-gray-300" />
                </button>
                <div>
                    <h1 className="text-xl font-semibold sm:text-2xl">Project Documents</h1>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                        Managing documents for project : {projectName}
                    </p>
                </div>
            </div>

            {/* Main Documents Component */}
            <div className="p-0 sm:p-0">
                {/* Pass the URL parameter down to your component as a Number */}
                <ProjectDocuments projectId={Number(projectId)} />
            </div>

        </div>
    );
}